// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19":"0520453c","877":"f63f8446"}[chunkId] + ".chunk.css";
};